import React from 'react';

const Button = ({ label, onButtonClick, icon, styleObj={} }) => {
  return (
    <button
      className="button, white, select-button"
      style={styleObj}
      onClick={onButtonClick}
    >
      {label}
      {icon? <img src={icon} alt="label" />: null}
    </button>
  )
}

export default Button;
